export enum EFaceElements {
    Empty = 1 << 0,        // 1
    Fill = 1 << 1,         // 2
    LeftPillar = 1 << 2,   // 4
    RightPillar = 1 << 3,  // 8
    Open = LeftPillar | RightPillar, // 12
    Full = Fill | LeftPillar | RightPillar, // 14
}
